import React from "react";
import { IIcons } from "./icons";

const Equal = ({ fillColor }: IIcons.IconProps) => {
  return (
    <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5787 2.0212H0.460938V0.59668H23.5787V2.0212Z"
        fill={fillColor ? fillColor : "#1D1D1D"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1412 7.8503H3.89844V6.42578H20.1412V7.8503Z"
        fill={fillColor ? fillColor : "#1D1D1D"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5104 13.406H9.53125V11.9814H14.5104V13.406Z"
        fill={fillColor ? fillColor : "#1D1D1D"}
      />
    </svg>
  );
};

export default Equal;
